import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import DialogBox from "../Dialog/Dialog.component";
import axios from 'axios';
import SingleSelect from "../dropdown/SingleSelect.component"
import { useSnackbar } from "notistack";
import ClipLoader from "react-spinners/ClipLoader";
import { get_content_type_chars } from "../../../config/apiUrls"

import './Table.css';

const useStyles = makeStyles({
  table: {
    minWidth: 700,
  },
  name: {
    fontFamily: "OpenSans",
    fontWeight: 600
  },
  divider: {
    borderLeft: "1px solid",
    margin: "3px 7px",
    height: 15
  },
  text: {
    fontFamily: "OpenSans",
    fontSize: "0.75rem",
    color: "#999",
    alignItems: "center"
  },
  textBold: {
    marginLeft: 3,
    fontWeight: 600
  },
  button: {
    '&:hover': {
      backgroundColor: "rgba(29, 141, 12, 1)"
    },
    '&.Mui-disabled': {
      backgroundColor: "rgba(38, 184, 16, 0.5)"
    },
    backgroundColor: "rgba(38, 184, 16, 1)"
  },
  button1: {
    '&:hover': {
      backgroundColor: "rgba(19, 88, 7, 1)"
    },
    '&.Mui-disabled': {
      backgroundColor: "rgba(38, 184, 16, 0.5)"
    },
    backgroundColor: "rgba(19, 88, 7, 1)"
  },
  tableCont: {
    marginTop: "20px !important",
    maxHeight: "calc(50vh - 140px)"
  }
});

const BodyTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    border: "1px solid #dde6ed",
    fontFamily: "OpenSansBold",
    fontSize: "0.8rem !important"
  },
  body: {
    fontSize: 14,
    border: "1px solid #dde6ed"
  },
}))(TableCell);

const BodyTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: "#f5f9fc",
    },
    '&:nth-of-type(even)': {
      backgroundColor: "#fff",
    }
  },
}))(TableRow);



export default function Tables(props) {
  const classes = useStyles();
  const [state, setState] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [contentTypeChars, setContentTypeChars] = useState(null)
  const [characterstics, setCharacterstics] = useState({})
  const [selectedIndex, setSelectedIndex] = useState(null);
  const { data, contentTypes, loading, period, spec, setSpec, network } = props;
  const { enqueueSnackbar } = useSnackbar();
  React.useEffect(() => {
    let finalData;
    let savedData = props.temp[network.network]
    if (data && data.length > 0) {
      finalData = data.map(el => {
        if (savedData && savedData.findIndex(data => data.contentType === el.contentType) > -1) {
          let index = savedData.findIndex(data => data.contentType === el.contentType)
          const { contentType, contentTypeDisplayName, charsAvailable, days } = savedData[index];

          return { contentType, contentTypeDisplayName, charsAvailable, days }
        }
        else {
          const { contentType, contentTypeDisplayName, charsAvailable, ...days } = el
          return { contentType, contentTypeDisplayName, charsAvailable, days }
        }
      })
      setState(finalData)
    }
  }, [data])

  const extractPromptSpec = (spec, instance) => {
    if (spec) {
      return spec[instance]
    }
  }

  React.useEffect(() => {
    if (state && state.length > 0) {
      let currentSpec = { ...spec }
      let promptSpec = extractPromptSpec(spec, "networks");
      if (promptSpec && promptSpec.length > 0) {
        let temp = promptSpec.findIndex(el => el.network === network.network);
        if (temp > -1) promptSpec[temp]["contentTypes"] = state.map(el => {
          return {
            contentType: el.contentType,
            days: el.days,
            characterstics: typeof (el.charsAvailable) === "object" ? el.charsAvailable : {}
          }
        }) //_omit(el, ["contentTypeDisplayName"])
        else promptSpec.push({
          network: network.network, contentTypes: state.map(el => {
            return {
              contentType: el.contentType,
              days: el.days,
              characterstics: typeof (el.charsAvailable) === "object" ? el.charsAvailable : {}
            }
          })
        })//_omit(, ["contentTypeDisplayName"]) })
      } else {
        promptSpec = [{
          network: network.network, contentTypes: state.map(el => {
            return {
              contentType: el.contentType,
              days: el.days,
              characterstics: typeof (el.charsAvailable) === "object" ? el.charsAvailable : {}
            }
          })
        }];
      }
      currentSpec["networks"] = promptSpec;
      setSpec(currentSpec);
      let value = { ...props.temp }
      value[network.network] = state
      props.setTemp(value)
    }
  }, [state])

  function dayHandler(event, id, day) {
    let value = event.target.value
    if (!isNaN(value) && parseInt(value) <= 1440) {
      let indv = { ...state[id] };
      indv["days"][day] = parseInt(value);
      let newVariable = [...state];
      newVariable[id] = { ...indv }
      setState(newVariable)
    }
  }
  const handleAddChars = (e, index, data) => {
    if (typeof (data.charsAvailable) === "object") {
      setCharacterstics(data.charsAvailable)
    }
    const contentTypeId = contentTypes.filter(el => el.contentType === data.contentType)[0].contentTypeId;
    setSelectedIndex(index);
    axios.get(get_content_type_chars + "/" + network.networkId + "/" + contentTypeId)
      .then((response) => {
        setContentTypeChars(response.data);
        setOpenDialog(true);
      }).catch((e) => {
        console.log('fetch failed');
      });
  }
  const handleCharsChange = (data, charType) => {
    let value = characterstics;
    value[charType.characteristic] = data
    setCharacterstics(value)
  }

  const handleSave = e => {
    const newState = [...state];
    newState[selectedIndex].charsAvailable = characterstics;
    setState(newState);
    setCharacterstics({})
    setOpenDialog(false);
    enqueueSnackbar("Characteristics Added Sucessfully", {
      variant: 'success',
      autoHideDuration: 1500
    })
  }
  return (
    <React.Fragment>
      <TableContainer className={classes.tableCont} component={Paper} style={{}} >
        <div style={{ display: "flex", height: 32, alignItems: "flex-end", padding: "5px 20px" }}>
          <div className={classes.name}>{network ?.networkDisplayName}</div>
          <div className={classes.text} style={{ display: "flex", marginLeft: "auto" }}>
            <div>Network :<span className={classes.textBold}>{network ?.networkDisplayName}</span></div>
            <div className={classes.divider} />
            <div>Year :<span className={classes.textBold}>{props.year ?.year}</span></div>
            <div className={classes.divider} />
            <div>Week {props.week ?.weekId}:<span className={classes.textBold}>{period}</span></div>
          </div>
        </div>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <BodyTableCell>Content Type</BodyTableCell>
              <BodyTableCell align="center">Monday</BodyTableCell>
              <BodyTableCell align="center">Tuesday</BodyTableCell>
              <BodyTableCell align="center">Wednesday</BodyTableCell>
              <BodyTableCell align="center">Thursday</BodyTableCell>
              <BodyTableCell align="center">Friday</BodyTableCell>
              <BodyTableCell align="center">Saturday</BodyTableCell>
              <BodyTableCell align="center">Sunday</BodyTableCell>
              <BodyTableCell align="center">Characteristics</BodyTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {state.map((row, index) => (
              <BodyTableRow key={index}>
                <BodyTableCell scope="row">
                  {row.contentTypeDisplayName}
                </BodyTableCell >
                <BodyTableCell align="center"><input type="text" value={row["days"].monday} onChange={(event) => dayHandler(event, index, "monday")} /></BodyTableCell>
                <BodyTableCell align="center"><input type="text" value={row["days"].tuesday} onChange={(event) => dayHandler(event, index, "tuesday")} /></BodyTableCell>
                <BodyTableCell align="center"><input type="text" value={row["days"].wednesday} onChange={(event) => dayHandler(event, index, "wednesday")} /></BodyTableCell>
                <BodyTableCell align="center"><input type="text" value={row["days"].thursday} onChange={(event) => dayHandler(event, index, "thursday")} /></BodyTableCell>
                <BodyTableCell align="center"><input type="text" value={row["days"].friday} onChange={(event) => dayHandler(event, index, "friday")} /></BodyTableCell>
                <BodyTableCell align="center"><input type="text" value={row["days"].saturday} onChange={(event) => dayHandler(event, index, "saturday")} /></BodyTableCell>
                <BodyTableCell align="center"><input type="text" value={row["days"].sunday} onChange={(event) => dayHandler(event, index, "sunday")} /></BodyTableCell>
                <BodyTableCell align="center">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ color: "white", fontSize: "9px" }}
                    disabled={!row.charsAvailable}
                    onClick={e => handleAddChars(e, index, row)}
                    classes={{ contained: typeof (row.charsAvailable) === "object" ? classes.button1 : classes.button }}
                  >
                    ADD CHARACTERISTICS
        </Button>
                </BodyTableCell>

              </BodyTableRow>
            ))}
          </TableBody>
        </Table>
        {
          loading && <div style={{ display: "flex", justifyContent: "center", padding: 10, height: 120 }}><ClipLoader color={"#1976d2"} loading={loading} size={100} /></div>
        }
      </TableContainer>
      <DialogBox open={openDialog} onClose={e => { setCharacterstics({}); setOpenDialog(false) }} onSave={handleSave} title={"Add Characteristics"}>
        <div style={{ width: 300 }}>
          {
            contentTypeChars && contentTypeChars.map(el => (
              <div style={{ display: "flex", alignItems: "center", margin: "10px 5px" }}>
                <div>{el.characteristicDisplayName}</div>
                <div style={{ marginLeft: "auto" }}>
                  <SingleSelect
                    items={el.characteristicParams}
                    defaultValue={characterstics[el.characteristic] ? characterstics[el.characteristic] : el.characteristicParams[0]}
                    onChange={value => handleCharsChange(value, el)}
                  />
                </div>
              </div>
            ))
          }
        </div>
      </DialogBox>
    </React.Fragment>

  );
}
